module.exports = {
    df_text_query:"https://chatbotservices.civitbuild.in/api/df_text_query",
    df_event_query:"https://chatbotservices.civitbuild.in/api/df_event_query",
}